import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarMenuComponent } from './sidebar-menu/sidebar-menu.component';
import { BaseLayoutComponent } from './base-layout/base-layout.component';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { DialogComponent } from './dialog/dialog.component';
import { LoadingComponent } from './loading/loading.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PaginationComponent } from './pagination/pagination.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TitleContentComponent } from './title-content/title-content.component';
import { DialogImageComponent } from './dialog-image/dialog-image.component';
import { DialogTextOverflowComponent } from './dialog-text-overflow/dialog-text-overflow.component';
import { MaterialModule } from 'src/app/core/material.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { QrCodeScannerComponent } from './qr-code-scanner/qr-code-scanner.component';
import { DropZoneImageComponent } from './drop-zone-image/drop-zone-image.component';



@NgModule({
  declarations: [
    SidebarMenuComponent,
    BaseLayoutComponent,
    HeaderComponent,
    DialogComponent,
    LoadingComponent,
    PaginationComponent,
    TitleContentComponent,
    DialogImageComponent,
    DialogTextOverflowComponent,
    QrCodeScannerComponent,
    DropZoneImageComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatProgressSpinnerModule,
    MaterialModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
  ],
  exports: [
    SidebarMenuComponent,
    BaseLayoutComponent,
    LoadingComponent,
    DialogComponent,
    PaginationComponent,
    TitleContentComponent,
    QrCodeScannerComponent,
    DropZoneImageComponent,
    DialogImageComponent
  ]
})
export class ShareModule { }
